export { HeaderSenichisaku } from './HeaderSenichisaku.jsx';
export { BodySenichisaku } from './BodySenichisaku.jsx';
export { FooterSenichisaku } from './FooterSenichisaku.jsx';
